import { useLocation, useMatch, useParams } from 'react-router-dom';


export function useRouteMatch<T extends {}>(pattern?: string) {
    const { pathname } = useLocation();
    const params = useParams();

    const defaultPattern = Object.entries(params).reduce(
        (prev, [ paramName, paramValue ]) => ((paramName === '*' || !paramValue) ? prev : prev.replace(
            paramValue as string, `:${paramName}`
        )), pathname
    );

    const match = useMatch(pattern || defaultPattern);

    return match as (typeof match & {params: T}) | null;
}
